export default __webpack_public_path__ + "static/media/term-life.99f14b29.svg";